import { __assign } from "tslib";
import { Field, Form } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import FadeIn from 'react-fade-in';
import InputMask from 'react-input-mask';
import { Error } from '../../../../components/Error';
import { AddressTypes, } from '../../../../stores/DetailsStore';
import { CheckAddress } from './components/CheckAddress';
export var DetailsOfficeworksForm = inject('checkAddressStore', 'appStore', 'config')(observer(function (props) {
    var appStore = props.appStore, detailsStore = props.detailsStore, errors = props.errors, touched = props.touched, values = props.values, setFieldValue = props.setFieldValue;
    var sharedAddressFormProps = {
        errors: errors,
        levelTypes: props.checkAddressStore.levelTypes,
        states: props.checkAddressStore.states,
        streetTypes: props.checkAddressStore.streetTypes,
        touched: touched,
        unitTypes: props.checkAddressStore.unitTypes,
        setFieldValue: setFieldValue,
        values: values,
    };
    return (React.createElement(Form, null,
        React.createElement("p", { className: "small" },
            "Officeworks respects your privacy. View our",
            ' ',
            React.createElement("a", { href: "https://www.officeworks.com.au/information/policies/privacy-policy", target: "_blank" }, "Privacy Policy.")),
        React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "isBusiness", className: "checkbox checkbox-square" },
                React.createElement(Field, { id: "isBusiness", name: "isBusiness", type: "checkbox", checked: values.isBusiness }),
                React.createElement("small", { className: "label" }, "I am a business"))),
        values.isBusiness && (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-6 form-group" },
                React.createElement("label", { htmlFor: "businessName" }, "Business Name"),
                React.createElement(Field, { id: "businessName", name: "businessName", component: "input", className: "form-control shadow-alt " + (errors.businessName &&
                        touched.businessName &&
                        'error') }),
                React.createElement(Error, { name: "businessName" })),
            React.createElement("div", { className: "col-md-6 form-group" },
                React.createElement("label", { htmlFor: "abn" },
                    "ABN ",
                    React.createElement("small", null, "(required if providing a Business name)")),
                React.createElement(Field, { id: "abn", name: "abn", component: "input", className: "form-control shadow-alt " + (errors.abn &&
                        touched.abn &&
                        'error') }),
                React.createElement(Error, { name: "abn" })))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-2" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { htmlFor: "title" }, "Title"),
                    React.createElement(Field, { id: "title", name: "title", component: "select", className: "form-control shadow-alt " + (errors.title &&
                            touched.title &&
                            'error') },
                        React.createElement("option", { value: "" }),
                        [
                            { display: 'Mr', value: 'Mr' },
                            { display: 'Mrs', value: 'Mrs' },
                            { display: 'Miss', value: 'Miss' },
                            { display: 'Ms', value: 'Ms' },
                            { display: 'Dr', value: 'Dr' },
                        ].map(function (option) { return (React.createElement("option", { key: option.value, value: option.value }, option.display)); })),
                    React.createElement(Error, { name: "title" }))),
            React.createElement("div", { className: "col-md-5" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { htmlFor: "firstName" }, "First name"),
                    React.createElement(Field, { id: "firstName", name: "firstName", component: "input", className: "form-control shadow-alt " + (errors.firstName &&
                            touched.firstName &&
                            'error'), onBlur: function (e) {
                            setFieldValue('firstName', e.currentTarget.value.trim());
                        } }),
                    React.createElement(Error, { name: "firstName" }))),
            React.createElement("div", { className: "col-md-5" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { htmlFor: "lastName" }, "Last name"),
                    React.createElement(Field, { id: "lastName", name: "lastName", component: "input", className: "form-control shadow-alt " + (errors.lastName &&
                            touched.lastName &&
                            'error'), onBlur: function (e) {
                            setFieldValue('lastName', e.currentTarget.value.trim());
                        } }),
                    React.createElement(Error, { name: "lastName" })))),
        React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "emailAddress" }, "Email address"),
            React.createElement(Field, { id: "emailAddress", name: "emailAddress", component: "input", className: "form-control shadow-alt " + (errors.emailAddress &&
                    touched.emailAddress &&
                    'error'), onChange: function (e) {
                    detailsStore.emailChanged = true;
                    props.setFieldValue('emailAddress', e.currentTarget.value);
                } }),
            React.createElement(Error, { name: "emailAddress" })),
        React.createElement("br", null),
        React.createElement("div", { className: "form__wrap form__wrap_inner form__wrap_inner_last" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("label", { htmlFor: "phoneNumber" }, "Phone"),
                    React.createElement("div", { className: "input-group" },
                        React.createElement("div", { className: "col-4 select-pinned pinned-left input-group-addon" },
                            React.createElement(Field, { id: "phoneType", name: "phoneType", component: "select", className: "form-control" },
                                React.createElement("option", { value: "mobile" }, "Mobile"),
                                React.createElement("option", { value: "home" }, "Home"),
                                React.createElement("option", { value: "work" }, "Work"))),
                        React.createElement(Field, { id: "phoneNumber", name: "phoneNumber", component: "input", className: "form-control shadow-alt " + (errors.phoneNumber &&
                                touched.phoneNumber &&
                                'error'), placeholder: "Phone" })),
                    React.createElement(Error, { name: "phoneNumber" }),
                    React.createElement("div", { id: "element" })),
                React.createElement("div", { className: "col-md-6 form-group" },
                    React.createElement("label", { htmlFor: "dateOfbirth" }, "Date of birth"),
                    React.createElement(Field, { id: "dateOfBirth", name: "dateOfBirth", render: function (field) { return (React.createElement(InputMask, __assign({}, field.field, { className: "form-control shadow-alt " + (errors.dateOfBirth &&
                                touched.dateOfBirth &&
                                'error'), mask: "99/99/9999", placeholder: "DD/MM/YYYY" }))); } }),
                    React.createElement(Error, { name: "dateOfBirth" })))),
        React.createElement("hr", null),
        React.createElement("label", { htmlFor: "billingAddressRequired", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "billingAddressRequired", name: "billingAddressRequired", type: "checkbox", checked: values.billingAddressRequired }),
            React.createElement("small", { className: "label" }, "My billing address is different to my service address")),
        values.billingAddressRequired && (React.createElement(FadeIn, null,
            React.createElement(CheckAddress, __assign({}, sharedAddressFormProps, { type: AddressTypes.Billing, label: 'Billing address details' })))),
        React.createElement("hr", null),
        React.createElement("label", { htmlFor: "deliveryAddressRequired", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "deliveryAddressRequired", name: "deliveryAddressRequired", type: "checkbox", checked: values.deliveryAddressRequired }),
            React.createElement("small", { className: "label" }, "My delivery address is different to my service address")),
        values.deliveryAddressRequired && (React.createElement(FadeIn, null,
            React.createElement(CheckAddress, __assign({}, sharedAddressFormProps, { type: AddressTypes.Delivery, label: 'Delivery address details' })))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: appStore.previousStep }, "Back"),
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
}));
//# sourceMappingURL=DetailsOfficeworksForm.js.map